module.exports = __webpack_public_path__ + "img/H1.00f550b1.png";